var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00AAAC;}\r\n\t.st1{fill:#F59C23;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#010202;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-logo_lrg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_x2F_reserved_x2F_payments"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M651.35,297.31c0,126.99-102.94,229.93-229.93,229.93S191.48,424.29,191.48,297.31 S294.43,67.37,421.41,67.37S651.35,170.32,651.35,297.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st1",
    d: "M587.6,297.31c0,91.78-74.41,166.19-166.19,166.19s-166.19-74.41-166.19-166.19 s74.41-166.19,166.19-166.19S587.6,205.52,587.6,297.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st2",
    d: "M421.41,456.67c-88.01,0-159.36-71.35-159.36-159.36s71.35-159.36,159.36-159.36 s159.36,71.35,159.36,159.36S509.43,456.67,421.41,456.67 M421.41,122.01c-96.81,0-175.29,78.48-175.29,175.29 S324.6,472.6,421.41,472.6s175.29-78.48,175.29-175.29S518.23,122.01,421.41,122.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st3",
    d: "M444.02,304.33c-9.96,11.77-17.82,25.65-22.61,40.79c-4.79-15.14-12.65-29.01-22.61-40.79h0 c-0.05-0.06-0.11-0.13-0.16-0.19h22.77h22.77C444.13,304.2,444.07,304.26,444.02,304.33L444.02,304.33z M421.42,279.85 c-11.92,0-23.92,0.3-35.9,0.89c-5.23-6.94-11.54-13.01-18.68-17.93c18.02-1.28,36.22-1.93,54.58-1.93 c36.34,0,72.07,2.55,107,7.47l1.97-18.71c-35.18-7.06-71.62-10.77-108.96-10.77c-37.34,0-73.79,3.71-108.96,10.77l1.97,18.71 c8.72-1.23,17.49-2.31,26.31-3.24c1.57-0.18,2.83,0.24,3.53,0.55c8.23,3.61,15.35,9.28,20.75,16.37 c-22.4,1.72-44.64,4.44-66.29,8.14l2.04,19.39c17.36-1.51,38.6-3.1,43.08-3.19c25.45-0.5,46.57,16.96,52.66,41.74 c4.21,17.7,1.98,40.56,1.39,51.64h23.53h23.53c-0.59-11.08-2.82-33.95,1.39-51.64c6.09-24.77,27.22-42.24,52.66-41.74 c4.48,0.09,25.72,1.69,43.08,3.19l2.04-19.39C504.3,283.37,462.47,279.86,421.42,279.85L421.42,279.85z M421.42,203.97 c-26.39,0-52.12,2.78-76.94,8.06l1.81,17.21c24.51-3.65,49.6-5.54,75.13-5.54c25.53,0,50.61,1.89,75.13,5.54l1.81-17.21 C473.54,206.75,447.8,203.97,421.42,203.97"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnb);
export default __webpack_public_path__ + "static/media/fnb.878879821a9d3efaa0c7e77f3d7e9923.svg";
export { ForwardRef as ReactComponent };